/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Uno_Welcome_Suggestion_Share_WorkflowsInputs */



/**
* | output |
* | --- |
* | "How do I share a project?" |
*
* @param {Uno_Welcome_Suggestion_Share_WorkflowsInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const uno_welcome_suggestion_share_workflows = /** @type {((inputs?: Uno_Welcome_Suggestion_Share_WorkflowsInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Uno_Welcome_Suggestion_Share_WorkflowsInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Wie teile ich ein Projekt?")
	return /** @type {LocalizedString} */ ("How do I share a project?")
});